import React, { ReactNode, useState } from 'react';

import { Button } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';

export interface IHiddenSection {
  title: string;
  content?: ReactNode | null;
}
export const HiddenSection = ({ title, content }: IHiddenSection) => {
  const [visible, setVisible] = useState(false);

  return (
    <Box style={styles.container}>
      <Box style={styles.header}>
        <Typography pt="$4" variant="headerThree">
          {title}
        </Typography>
        <Button onPress={() => setVisible(v => !v)} size={'md'} variant="ghost">
          {visible ? 'Hide Section' : 'Show Section'}
        </Button>
      </Box>
      {visible ? content : null}
    </Box>
  );
};

const styles = StyleSheet.create({
  container: { paddingBottom: 8, width: '100%' },
  header: { alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between' },
});
